<div class="conditions-root">
  <!-- QUESTION CONDITIONS -->
  @if (conditions.questionConditions) {
    <div class="context-line">
      <span>
        {{
          "preview.condition.conditionsmustbefulfilledforquestionbelow"
            | translate
        }}
      </span>
    </div>

    <div class="tree">
      <ng-container
        [ngTemplateOutlet]="renderGroup"
        [ngTemplateOutletContext]="{
          group: conditions.questionConditions,
          depth: 0,
        }"
      ></ng-container>
    </div>
  }

  <!-- ROW CONDITIONS -->
  @if (conditions.rowConditions?.length) {
    @for (row of conditions.rowConditions; track $index) {
      <div class="context-line">
        <span>
          {{
            "preview.condition.rowonlyshownifconditionsaremet"
              | translate: { questionname: row.text }
          }}
        </span>
      </div>

      <div class="tree">
        <ng-container
          [ngTemplateOutlet]="renderGroup"
          [ngTemplateOutletContext]="{ group: row.items, depth: 0 }"
        ></ng-container>
      </div>
    }
  }

  <!-- ALTERNATIVE CONDITIONS -->
  @if (conditions.alternativeConditions?.length) {
    @for (alt of conditions.alternativeConditions; track $index) {
      <div class="context-line">
        <span>
          {{
            "preview.condition.alternativeonlyshownifconditionsaremet"
              | translate: { alternative: alt.text }
          }}
        </span>
      </div>

      @if (alt.items) {
        <div class="tree">
          <ng-container
            [ngTemplateOutlet]="renderGroup"
            [ngTemplateOutletContext]="{ group: alt.items, depth: 0 }"
          ></ng-container>
        </div>
      }
    }
  }

  <!-- ACTIONS / QUOTAS (wrapped to avoid grid-gap between label and list) -->
  @if (conditions.actions) {
    <div class="meta-block">
      <div class="context-line">{{ conditions.actions.text }}</div>

      @if (conditions.actions.list.length) {
        <ul class="alternatives">
          @for (x of conditions.actions.list; track $index) {
            <li>{{ x }}</li>
          }
        </ul>
      }
    </div>
  }

  @if (conditions.quotas) {
    <div class="meta-block">
      <div class="context-line">{{ conditions.quotas.text }}</div>

      @if (conditions.quotas.list.length) {
        <ul class="alternatives">
          @for (x of conditions.quotas.list; track $index) {
            <li>{{ x }}</li>
          }
        </ul>
      }
    </div>
  }

  <!-- ========================= -->
  <!-- Recursive templates below -->
  <!-- ========================= -->

  <ng-template #renderGroup let-group="group" let-depth="depth">
    <div class="group" [ngClass]="depthClass(depth)">
      @if (group.text) {
        <div class="group-title">{{ group.text }}</div>
      }

      <div class="group-tree">
        @for (node of group.items; track trackByStable(node, $index)) {
          <!-- CHILD ROW -->
          <div class="tree-row tree-row--node">
            <div class="tree-gutter">
              <span class="branch"></span>
            </div>

            <div class="tree-content">
              @if (isGroup(node)) {
                <ng-container
                  [ngTemplateOutlet]="renderGroup"
                  [ngTemplateOutletContext]="{ group: node, depth: depth + 1 }"
                ></ng-container>
              }

              @if (isItem(node)) {
                <ng-container
                  [ngTemplateOutlet]="renderItem"
                  [ngTemplateOutletContext]="{ item: node }"
                ></ng-container>
              }
            </div>
          </div>

          <!-- OPERATOR SEPARATOR ROW (between siblings only) -->
          @if ($index < group.items.length - 1) {
            <div class="tree-row tree-row--op">
              <div class="tree-gutter tree-gutter--op">
                <span class="op-badge">{{
                  operatorLabel(group.operator)
                }}</span>
              </div>
              <div class="tree-content"></div>
            </div>
          }
        }
      </div>
    </div>
  </ng-template>

  <ng-template #renderItem let-item="item">
    <div class="leaf">
      <div class="leaf-text">{{ item.text }}</div>

      @if (item.list?.length) {
        <ul class="alternatives">
          @for (x of item.list; track $index) {
            <li>{{ x }}</li>
          }
        </ul>
      }
    </div>
  </ng-template>
</div>
